






















import Vue from 'vue';

export default Vue.extend({
  name: 'SignOutMessage',
  data() {
      return {
          title: 'Success!',
          text: 'You have successfully signed out. Thanks for staying secure.',
      };
  },
});
